export default `
  subscription onUpdateTeamMemberLastLogin($projectId: String!)  {
    onUpdateTeamMemberLastLogin (projectId: $projectId) {
      id
      projectId
      lastLogin
      createdAt
    }
  }
`
